<template>
<div>
  <v-card>
    <v-card-title>
      {{ `${keyText} - ${day === 'today' ? today : tomorrow}` }}
      <v-spacer></v-spacer>
      <v-layout justify-end wrap>
        <v-flex xs12 sm8 md6>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Wyszukaj"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="football[day][dataKey]"
      :footer-props="{
        'items-per-page-options': [10, 20, 50],
        'items-per-page-text': 'Liczba wierszy'
      }"
      :items-per-page="itemsPerPage"
      :class="['elevation-1', tableClass]"
      :search="search"
      :loading="loading"
    >
      <template v-slot:header.link="{ header }">
        {{ header.text }}
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon color="grey" dark v-on="on">help</v-icon>
          </template>
          <span>
            Dane od 2014 roku
          </span>
        </v-tooltip>
      </template>
      <template v-slot:header.average="{ header }">
        {{ header.text }}
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon color="grey" dark v-on="on">help</v-icon>
          </template>
          <span>
            Dane od 2014 roku
          </span>
        </v-tooltip>
      </template>
      <template v-slot:item.url="{ item }">
        <v-btn :href="item.url" target="_blank" color="primary" text icon small>
          <v-icon>mdi-link</v-icon>
        </v-btn>
      </template>

      <template v-slot:item.link="{ item }">
        <v-btn
          v-for="fix in item[dataKey]"
          :key="fix.url"
          :href="fix.url"
          class="v-data-table__button"
          target="_blank"
          color="primary"
          small
          depressed
        >
          {{ formatDate(fix.date.year, fix.date.month, fix.date.day) }}
        </v-btn>
      </template>
      <template v-slot:item.average="{ item }">
        {{ item.average }}
      </template>

      <template v-slot:loading>
        Ładowanie..
      </template>
      <template v-slot:no-data>
        Brak danych
      </template>

      <template v-slot:no-results>
        Nie znaleziono danych
      </template>

      <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
        {{ pageStart }} - {{ pageStop }} z {{ itemsLength }}
      </template>
    </v-data-table>
  </v-card>
  <!-- <v-layout>
    <v-flex xs12 class="d-flex justify-start mt-2">
      <span>Projekt wspierany przez</span>
      <a
        href="https://www.facebook.com/SzukamyUstawek"
        target="__blank"
        class="ml-1"
      >
        Szukamy Ustawek
      </a>
    </v-flex>
  </v-layout> -->
</div>
</template>

<script>
import axios from "@/api";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    headers: {
      type: Array,
      required: true
    },
    itemsPerPage: {
      type: Number,
      default: 20
    },
    type: {
      type: String,
      required: true
    },
    day: {
      type: String,
      required: true
    },
    dataKey: {
      type: String,
      required: true
    },
    tableClass: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    search: "",
    loading: false
  }),
  created() {
    if (!this.football[this.day][this.dataKey].length) {
      this.loading = true
      axios.get(`/${this.type}/${this.day}/${this.dataKey}`).then(response => {
        this.loading = false

        this.updateState({
          type: this.type,
          day: this.day,
          key: this.dataKey,
          items: response.data
        });
      });
    }
  },
  computed: {
    ...mapGetters(['football']),
    today() {
      return moment().format("DD.MM.YYYY")
    },
    tomorrow() {
      return moment().add(1, 'day').format("DD.MM.YYYY")
    },
    keyText() {
      return this.headers[this.headers.length -1].text
    }
  },
  methods: {
    ...mapActions(["updateState"]),
    formatDate(year, month, day) {
      return `${this.getValue(day)}.${this.getValue(month)}.${year}`;
    },
    getValue(value) {
      return  (`0${value}`).slice(-2)
    }
  }
};
</script>
